module.exports = __webpack_public_path__ + "static/media/selo-ouro-de-inovacao.2f73f405.pdf";